import {Component, Input, OnInit} from '@angular/core';
import {ZapisnyList} from '../model/zapisnyList';
import {AppService} from '../app.service';
import {TranslateService} from '@ngx-translate/core';
import {Studium} from '../model/studium';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-zapisne-listy',
  templateUrl: './zapisne-listy.component.html',
  styleUrls: ['./zapisne-listy.component.css']
})
export class ZapisneListyComponent
{
    @Input()
    studium: Studium;

    show = true;

    constructor(
      private appService: AppService,
      private translation: TranslateService,
      private http: HttpClient
    ) {
    }

    vytvoritZapisnyList()
    {
        const url = '/ais/rest/portal/zapisny-list/' + this.studium.id + '/' + this.studium.zapisnyListNext.akRok.replace('/', '-');

        const msg = this.translation.instant('zapisny_list_bol_vytvoreny');

        this.http.post(url, null)
          .subscribe({
            next: () => {
                this.appService.fetchStudia(true);
                this.appService.openConfirmDialogReturnsDialog(msg)
                  .afterClosed()
                  .subscribe((res) => {
                      if (res === 'OK') {
                          this.goToPredmety();
                      }
                  });
              },
            error: (error) => {
              if (error instanceof HttpErrorResponse) {
                this.appService.openErrorDialog(error.error.message);
              }
            }
          });
    }

    vytvoritElektronickyZapis() {
        window.location.href = '/ais/apps/zapis/' + this.translation.currentLang.toLowerCase() + '?studium=' + this.studium.id;
    }

    private goToPredmety()
    {
        this.studium = this.appService.getStudiumById(this.studium.id);

        const zapisnyList = this.studium.zapisneListy[0];

        console.log(zapisnyList);

        const url =
          '/ais/apps/student-predmety/'
          + this.translation.currentLang.toLowerCase()
          + '?zl=' + zapisnyList.id;

        window.location.href = url;
    }

}
